import { defineEvent } from '../types/event';
export var CART_VIEW = defineEvent({
    platforms: [
        {
            name: 'GTM',
            alias: 'view_cart'
        }
    ]
});
